import React from 'react';

export default function UnverifiedIngredientsModal({
  count,
  onConfirm,
  onCancel,
}) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4">
          You have {count} unverified ingredient{count > 1 ? 's' : ''}
        </h2>
        <p className="mb-6 text-gray-700">
          Recipes with unverified ingredients won’t be publicly searchable until
          our team verifies them.
        </p>
        <div className="flex justify-end space-x-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded border text-gray-700 hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded bg-primary text-white hover:bg-green-600"
          >
            Continue anyway
          </button>
        </div>
      </div>
    </div>
  );
}
